import { render, staticRenderFns } from "./legals.vue?vue&type=template&id=5fce8912&"
import script from "./legals.vue?vue&type=script&lang=js&"
export * from "./legals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports